export function addLeadingZero(number: string | number) {
  return ('0' + number).slice(-2);
}

export function countDaysSinceDate(dateString: string | Date): number {
  const pastDate = new Date(dateString);
  const today = new Date();

  pastDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInMs = today.getTime() - pastDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.floor(diffInDays);
}
